import { render, staticRenderFns } from "./DocTypeInfoModal.vue?vue&type=template&id=b30bf9aa&scoped=true&"
import script from "./DocTypeInfoModal.vue?vue&type=script&lang=ts&"
export * from "./DocTypeInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./DocTypeInfoModal.vue?vue&type=style&index=0&id=b30bf9aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30bf9aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VExpansionPanels,VIcon,VTooltip})
